import styled from "styled-components";

export const ThemeControlBtn = styled.button`
  border: none;
  background: none;
  padding: 0.5rem;
  cursor: pointer;
`;
export const ThemeControlImg = styled.img``;
